import React from "react";
import { Box, Sheet, Typography } from "@mui/joy";

interface AuthLayoutProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  footer?: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  title,
  subtitle,
  footer,
}) => {
  return (
    <Sheet
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#FDF8F5", // Warm off-white
        padding: 3,
      }}
    >
      <Box sx={{ maxWidth: 400, width: "100%", textAlign: "center" }}>
        {title && (
          <Typography level="h2" sx={{ mb: 1, color: "#1A1A1A" }}>
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography level="body-md" sx={{ mb: 4, color: "#6B6B6B" }}>
            {subtitle}
          </Typography>
        )}
        {children}
      </Box>
      {footer && (
        <Box sx={{ mt: 3, textAlign: "center" }}>{footer}</Box>
      )}
    </Sheet>
  );
};
